<template>
    <div class="messageScreen" v-if="primaryMessageScreen">
        <div class="messageScreen__image">
            <img :src="srcImageMessage" alt="">
        </div>
        <div class="messageScreen__text" >
            <h2>{{ titleMessage }}</h2>
            <p>{{ message }}</p>
            <p v-if="isVisibleSecondaryMessage">{{ secondaryMessage }}</p>
        </div>
    </div>
    <div class="container gap-32" v-else>
        <div class="messageScreen-custom">
            <div class="messageScreen__image">
            <img :src="srcImageMessage" alt="">
        </div>
        <div class="messageScreen__text" >
            <h2>{{ titleMessage }}</h2>
            <p>{{ message }}</p>
            <p v-if="isVisibleSecondaryMessage">{{ secondaryMessage }}</p>
        </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            srcImageMessage: {
                type: String,
                required: true
            },
            titleMessage: {
                type: String,
                required: true
            },
            message: {
                type: String,
                required: false
            },
            isVisibleSecondaryMessage: {
                type: Boolean,
                required: false,
                default: false
            },
            secondaryMessage: {
                type: String,
                required: false,
            },
            primaryMessageScreen: {
                type: Boolean,
                required: false,
                default: true
            }
        }
    }
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .custom-container-final {
        height: 90vh;
    }
    .messageScreen{
        display: flex;
        height: 70vh;
        flex-direction: column;
        align-self: center;
        align-items: center;
        justify-content: center;
        gap: 48px;
    }
    .messageScreen-custom{
        display: flex;
        height: 90vh;
        flex-direction: column;
        align-self: center;
        align-items: center;
        justify-content: center;
        gap: 48px;
    }
    .messageScreen__text{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 24px;
        width: 90%;
    }
    .messageScreen__text h2{
        font-size: 20px;
        color: color-text-primary;
    }
    .messageScreen__text{
        display: flex;
        flex-direction: column;
        gap: 20p;
    }
    .messageScreen__text p{
        font-size: 16px;
        color: #435254;
        margin: 0px;
        text-align: center;
    }
</style>
